<template>
    <div class="rich-text">
        <div v-if="readonly || invisible" 
            class="rich-textarea-text readonly-text" 
            :class="{'invisible':invisible}" 
            :title="value"
            @dblclick="dblclickHandle"
            @mousedown.stop
            @click="clickHandle"
        >{{value}}</div>
        <div v-else 
            class="rich-textarea" 
            :style="{borderColor: active ? 'rgba(0, 122, 255, 0.5)': ''}" 
            :class="{'validate-error':!validateResult,'readonly':readonly}" 
            @mousedown.stop
            @click="showTextarea"
        >
            <div class="rich-textarea-title" :title="value">{{value}}</div>
            <div class="validate-error-icon" v-if="validateResult===false" @click.stop>
                <info-image @mouseenter.stop="errorIconMouseenter" @mouseleave="errorIconMouseleave"></info-image>
            </div>
        </div>
    </div>
</template>

<script>
import Gikam from "../../../core/gikam-core";
import infoImage from "../img/info.vue";
import BaseField from "../baseField/baseField.vue";
import Vue from "vue";
export default {
    extends: BaseField,
    components: { infoImage },

    props: {
        options: Object,
        propValue: [String, Number],
        propReadonly: Boolean,
        rowIndex: Number,
        //编辑器中的边框等样式是否显示出来
        propInvisible: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            validateResult: true,
            readonly: Gikam.isNotEmpty(this.propReadonly) ? this.propReadonly : this.options.readonly,
            value: this.propValue,
            field: this.options.field,
            active: false,
            invisible: this.propInvisible
        }
    },

    watch: {
        value(val) {
            this.valueIsChange = true;
            if (this.validate()) {
                this.validateResult = true;
                this.$emit(
                    "change",
                    this.options.field,
                    val,
                    this.rowIndex
                );
            } else {
                this.validateResult = false;
            }
        },

        propValue(val) {
            this.value = val;
        },

        invisible(bool) {
            if(bool && Gikam.textareaPicker) {
                Gikam.textareaPicker.close();
            }
        }
    },

    methods: {
        showTextarea() {
            if (Gikam.textareaPicker) {
                if (Gikam.textareaPicker.rowIndex === this.rowIndex) {
                    Gikam.textareaPicker.close();
                    return;
                }
                Gikam.textareaPicker.close();
            }

            const _this = this;
            const {top, bottom, left, right, width} = this.$el.getBoundingClientRect();
            const $top = document.body.clientHeight > bottom + 100 ? bottom + 4 : top - 100;
            const $right = left < 350 ? (document.body.clientWidth - right + width - 320) : (document.body.clientWidth - right);
            this.active = true;
            
            Gikam.textareaPicker = new Vue({
                el: Gikam.createDom('div', document.body),
                data() {
                    return {
                        value: _this.value,
                        top: $top + 'px',
                        right: $right + 'px',
                        style: {
                            width: '100%',
                            height: '100%',
                            border: 'none',
                            outline: 'none',
                            fontSize: '12px',
                            resize: 'none',
                            fontFamily: 'inherit',
                            color: 'rgba(0, 0, 0, 0.65)'
                        }
                    }
                },
                methods: {
                    close() {
                        _this.value = this.$refs.textarea.value.trim();
                        _this.clearTextareaPicker();
                    }
                },
                render() {
                    return (
                        <div class="textarea-picker" 
                            style={{top: this.top,right: this.right}}
                            onClick={e=>e.stopPropagation()}
                            onmousedown={e=>e.stopPropagation()}
                            onmousewheel={e=>e.stopPropagation()}>
                            <div class="close" onClick={()=>{this.close()}}>×</div>
                            <textarea ref="textarea" value={this.value} style={this.style} autofocus readonly={_this.readonly}/>
                        </div>
                    )
                }
            })
            Gikam.textareaPicker.rowIndex = this.rowIndex;
            Gikam.textareaPicker.$refs.textarea.focus();
        },

        clearTextareaPicker() {
            this.active = false;
            Gikam.textareaPicker.$destroy();
            Gikam.removeDom(Gikam.textareaPicker.$el);
            Gikam.textareaPicker = null;
        },

        errorIconMouseenter(event) {
            this.showErrorPanel(event);
        },

        errorIconMouseleave(event) {
            this.removeErrorPanel(event);
        },

        dblclickHandle() {
            this.$emit("dblclick", this);
        },

        clickHandle() {
            if(this.readonly) {
                this.showTextarea();
            }
            this.$emit("click", this);
        },

        focus() {
            this.showTextarea();
            this.active = true;
        }
    }
}
</script>
<style>
.rich-text {
    width: 100%;
}

.rich-textarea {
    display: flex;
    align-items: center;
    width: 100%;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    padding-left: 8px;
    color: rgba(0, 0, 0, 0.65);
    font-family: "Microsoft YaHei", serif;
    font-size: 12px;
    height: 100%;
    background-color: #fff;
}

.rich-textarea.validate-error {
    border-color: #ff6e6e;
    padding-right: 25px;
}

.rich-textarea .rich-textarea-title {
    width: 100%;
    min-height: 24px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    padding: 0 8px 0 0;
}

.rich-textarea .rich-textarea-icon {
    width: 14px;
    margin: 2px 5px 0 0;
    cursor: pointer;
}

.textarea-picker {
    position: absolute;
    width: 320px;
    height: 100px;
    z-index: 11;
    padding: 10px 0 10px 10px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow:  2px 2px 10px 2px rgba(9, 45, 83, 0.4)
}

.textarea-picker textarea {
    padding-right: 10px;
}

.textarea-picker .close {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 16px;
    height: 16px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    line-height: 13px;
    border-radius: 50%;
    cursor: pointer;
    background-color: #999;
    z-index: 11;
}

.rich-textarea-text.invisible.readonly-text {
    height: 100%;
    padding-left: 8px;
    border: none;
    background-color: transparent;
}
</style>